import React from 'react';
import { CreateModifierGroupsState } from './createModifierGroupsState/CreateModifierGroupsState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const CreateModifierGroupsPageV2: React.FC = () => {
	return (
		<CreateModifierGroupsState>
			<Forms />
			<ModalWindows />
		</CreateModifierGroupsState>
	);
};
